/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friends_My_Code_HelpInputs */

const en_friends_my_code_help = /** @type {(inputs: Friends_My_Code_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pass it on: whoever enters it becomes your friend.`)
};

const de_friends_my_code_help = /** @type {(inputs: Friends_My_Code_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebt ihn weiter: wer ihn eingibt, ist mit euch befreundet.`)
};

/**
* | output |
* | --- |
* | "Pass it on: whoever enters it becomes your friend." |
*
* @param {Friends_My_Code_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_my_code_help = /** @type {((inputs?: Friends_My_Code_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_My_Code_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_my_code_help(inputs)
	return en_friends_my_code_help(inputs)
});